// extracted by mini-css-extract-plugin
export default {"Container":"MatterportEducationalOverlay-module__Container--EnewH","Dismiss":"MatterportEducationalOverlay-module__Dismiss--zvTDQ"};